/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
import * as Types from "../../../../../../__graphql__/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetProductWithBbdQueryVariables = Exact<{
  sku: string | number;
}>;

export type GetProductWithBbdQuery = {
  getProduct: {
    bbd: string | null;
    bio: boolean | null;
    imageUrl: string | null;
    minDaysToBestBeforeDate: number | null;
    name: string;
    sku: string;
    countryOfOrigin: { code: string | null };
    inventoryEntry: { shelfNumber: string | null; stock: { shelf: number } | null };
  };
};

export const GetProductWithBbdDocument = gql`
  query getProductWithBBD($sku: ID!) {
    getProduct(input: { sku: $sku }) {
      bbd
      bio
      imageUrl
      minDaysToBestBeforeDate
      name
      sku
      countryOfOrigin {
        code
      }
      inventoryEntry {
        shelfNumber
        stock {
          shelf
        }
      }
    }
  }
`;

/**
 * __useGetProductWithBbdQuery__
 *
 * To run a query within a React component, call `useGetProductWithBbdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductWithBbdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductWithBbdQuery({
 *   variables: {
 *      sku: // value for 'sku'
 *   },
 * });
 */
export function useGetProductWithBbdQuery(
  baseOptions: Apollo.QueryHookOptions<GetProductWithBbdQuery, GetProductWithBbdQueryVariables> &
    ({ variables: GetProductWithBbdQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetProductWithBbdQuery, GetProductWithBbdQueryVariables>(
    GetProductWithBbdDocument,
    options,
  );
}
export function useGetProductWithBbdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetProductWithBbdQuery,
    GetProductWithBbdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetProductWithBbdQuery, GetProductWithBbdQueryVariables>(
    GetProductWithBbdDocument,
    options,
  );
}
// @ts-ignore
export function useGetProductWithBbdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetProductWithBbdQuery,
    GetProductWithBbdQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetProductWithBbdQuery, GetProductWithBbdQueryVariables>;
export function useGetProductWithBbdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetProductWithBbdQuery, GetProductWithBbdQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GetProductWithBbdQuery | undefined,
  GetProductWithBbdQueryVariables
>;
export function useGetProductWithBbdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetProductWithBbdQuery, GetProductWithBbdQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetProductWithBbdQuery, GetProductWithBbdQueryVariables>(
    GetProductWithBbdDocument,
    options,
  );
}
export type GetProductWithBbdQueryHookResult = ReturnType<typeof useGetProductWithBbdQuery>;
export type GetProductWithBbdLazyQueryHookResult = ReturnType<typeof useGetProductWithBbdLazyQuery>;
export type GetProductWithBbdSuspenseQueryHookResult = ReturnType<
  typeof useGetProductWithBbdSuspenseQuery
>;
export type GetProductWithBbdQueryResult = Apollo.QueryResult<
  GetProductWithBbdQuery,
  GetProductWithBbdQueryVariables
>;
